export interface SalesInvoiceOrderReport {
  orderNo: number;
  customerOrderNo: string;
  customerOrderRef: string;
}
